import React from 'react'
import { OrderList } from './list/page'

export const OrdersPage = (): JSX.Element => {
  return <OrderList></OrderList>
}
